"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var queries_1 = require("./queries");
var mappers_1 = require("./mappers");
var mapVideosResp = function (resp) {
    return {
        total: resp.total,
        cursor: resp.cursor,
        data: resp.entities.map(function (video) { return mappers_1.mapGqlPublicVideoToOld(video); }),
    };
};
var PublicChannelService = /** @class */ (function () {
    function PublicChannelService(client) {
        this.client = client;
    }
    PublicChannelService.prototype.getChannelVideos = function (opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_VIDEOS_QUERY, opts)];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, mapVideosResp(resp.channel.videos)];
                }
            });
        });
    };
    PublicChannelService.prototype.getWidgetData = function (_opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var singleVideoId, opts, _a, resp, singleVideo, channel, videos;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        singleVideoId = _opts.singleVideoId, opts = tslib_1.__rest(_opts, ["singleVideoId"]);
                        return [4 /*yield*/, Promise.all([
                                this.client.request(queries_1.GET_WIDGET_DATA_QUERY, opts),
                                singleVideoId ? this.getVideo(singleVideoId) : null,
                            ])];
                    case 1:
                        _a = _b.sent(), resp = _a[0], singleVideo = _a[1];
                        channel = mappers_1.mapGqlPublicChannelToOld(resp.channel);
                        videos = mapVideosResp(resp.channel.videos);
                        return [2 /*return*/, { channel: channel, videos: videos, singleVideo: singleVideo }];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannel = function (channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp, channel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_QUERY, {
                            channelId: channelId,
                        })];
                    case 1:
                        resp = _a.sent();
                        channel = mappers_1.mapGqlPublicChannelToOld(resp.channel);
                        return [2 /*return*/, channel];
                }
            });
        });
    };
    PublicChannelService.prototype.getVideo = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_VIDEO_QUERY, { videoId: videoId })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, mappers_1.mapGqlPublicVideoToOld(resp.video)];
                }
            });
        });
    };
    PublicChannelService.prototype.getVideoPlayUrls = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_VIDEO_PLAY_URLS_QUERY, {
                            videoId: videoId,
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                downloadUrl: resp.video.download.entity.url,
                                'hls.m3u8': resp.video.play.entity.hls,
                            }];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannelTrailerUrl = function (channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_PLAY_URL_QUERY, {
                            channelId: channelId,
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                'hls.m3u8': resp.channel.play.entity.hls,
                            }];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannelVideosPaymentData = function (channelId, videoIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp, _a, videos, channel;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_VIDEOS_PAYMENT_DATA_QUERY, { channelId: channelId, videoIds: videoIds })];
                    case 1:
                        resp = _b.sent();
                        _a = resp.channel, videos = _a.videos, channel = tslib_1.__rest(_a, ["videos"]);
                        return [2 /*return*/, {
                                channel: mappers_1.mapGqlPublicChannelPayment(channel),
                                videos: videos.entities.map(mappers_1.mapGqlPublicVideoPayment),
                            }];
                }
            });
        });
    };
    return PublicChannelService;
}());
exports.PublicChannelService = PublicChannelService;
//# sourceMappingURL=channel.js.map